import { Button } from "@material-ui/core";
import * as React from "react";
import { Link } from "react-router-dom";
import { ICharacter } from "../../containers/Members/CharacterList";

interface ICharacterItemProps {
    character: ICharacter;
}

const CharacterItem: React.FunctionComponent<ICharacterItemProps> = ({
    character,
}) => {
    const [display, setDisplay] = React.useState<boolean>(false);
    const link = "/members/character/" + character.id;

    /***************************************************
     * Event handlers
     ***************************************************/
    const handleDisplayClicked = () => {
        setDisplay(!display);
    };

    /***************************************************
     * Render
     ***************************************************/
    return (
        <div className="alternate-table-entry p-2">
            {/* Mobile */}
            <div className="d-flex flex-column d-md-none">
                <div className="d-flex align-items-center">
                    <Button
                        variant="contained"
                        className="action-button dark-red-button rounded-0"
                        onClick={handleDisplayClicked}
                    >
                        {display ? (
                            <i className="fas fa-chevron-down" />
                        ) : (
                            <i className="fas fa-chevron-right" />
                        )}
                    </Button>
                    <Link
                        className="forum-category-link flex-grow-1 ml-2"
                        to={link}
                    >
                        {character.name}
                    </Link>
                </div>
                {display === false ? null : (
                    <>
                        <span className="mt-3 font-small">Account</span>
                        <span>
                            {character.accountId ? character.accountName : ""}
                        </span>
                    </>
                )}
            </div>

            {/* Desktop */}
            <div className="d-none d-md-flex row w-100">
                <div className="d-flex align-items-center col-6">
                    <Link
                        className="w-100 forum-category-link"
                        to={link}
                    >
                        {character.name}
                    </Link>
                </div>
                <div className="d-flex align-items-center col-6">
                    {character.accountId ? character.accountName : ""}
                </div>
            </div>
        </div>
    );
};

export default CharacterItem;
